/* ============================================================
   DON JUAN x GLOPEERS — comportamiento comun
   Sin dependencias. No toca APIs de Horizon ni el checkout.

   NOTA DE COEXISTENCIA (auditoria 2026-09-02):
   sections/top3-premium.liquid ya usa el atributo [data-dj-countdown]
   para su propio reloj (.dj-clock con [data-days]/[data-hours]).
   Para NO pisarlo, este script usa un atributo distinto:
   [data-dj-week-countdown]. Los dos relojes conviven sin chocar.
   ============================================================ */
(function () {
  'use strict';

  /* ---------------------------------------------------------
     1. CONTADOR HASTA EL DOMINGO 11:59 PM (hora Colombia, UTC-5)
     --------------------------------------------------------- */

  var BOGOTA_OFFSET_MIN = -5 * 60; // Colombia no usa horario de verano

  function nextSundayCutoffUTC(nowMs) {
    var bog = new Date(nowMs + BOGOTA_OFFSET_MIN * 60000);
    var day = bog.getUTCDay(); // 0 = domingo
    var daysToSunday = (7 - day) % 7;

    var cutoff = Date.UTC(
      bog.getUTCFullYear(),
      bog.getUTCMonth(),
      bog.getUTCDate() + daysToSunday,
      23, 59, 59, 0
    );

    if (cutoff <= bog.getTime()) cutoff += 7 * 24 * 3600 * 1000;

    return cutoff - BOGOTA_OFFSET_MIN * 60000;
  }

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function tickCountdown(el) {
    var target = nextSundayCutoffUTC(Date.now());
    var diff = Math.max(0, target - Date.now());

    var s = Math.floor(diff / 1000);
    var d = Math.floor(s / 86400); s -= d * 86400;
    var h = Math.floor(s / 3600);  s -= h * 3600;
    var m = Math.floor(s / 60);    s -= m * 60;

    var set = function (attr, val) {
      var node = el.querySelector('[data-dj-' + attr + ']');
      if (node) node.textContent = pad(val);
    };

    set('d', d); set('h', h); set('m', m); set('s', s);
  }

  var timer = null;

  function initCountdowns() {
    var nodes = document.querySelectorAll('[data-dj-week-countdown]');
    if (!nodes.length) return;
    nodes.forEach(function (el) { tickCountdown(el); });
    if (timer) clearInterval(timer);
    timer = setInterval(function () {
      document.querySelectorAll('[data-dj-week-countdown]').forEach(function (el) {
        tickCountdown(el);
      });
    }, 1000);
  }

  /* ---------------------------------------------------------
     2. UN SOLO SISTEMA DE WHATSAPP
     Si existe un FAB de Don Juan, marcamos el body para que el
     CSS esconda la burbuja flotante de Shopify Inbox.
     chat-drawer.liquid NO se modifica: el chat sigue disponible
     desde su drawer y todo es reversible desde el editor.
     --------------------------------------------------------- */
  function initSingleWhatsapp() {
    var fab = document.querySelector('[data-dj-fab]');
    if (!fab) return;
    if (fab.getAttribute('data-dj-solo') === 'true') {
      document.body.classList.add('dj-wa-solo');
    } else {
      document.body.classList.remove('dj-wa-solo');
    }
  }

  /* ---------------------------------------------------------
     3. MENSAJE DE WHATSAPP CON CONTEXTO DE PAGINA
     --------------------------------------------------------- */
  function initWhatsappContext() {
    document.querySelectorAll('[data-dj-wa-context]').forEach(function (a) {
      var href = a.getAttribute('href');
      if (!href || href.indexOf('%7Bpage%7D') === -1) return;
      a.setAttribute('href', href.replace('%7Bpage%7D', encodeURIComponent(window.location.href)));
    });
  }

  function boot() {
    initCountdowns();
    initSingleWhatsapp();
    initWhatsappContext();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // El editor de temas reinyecta secciones sin recargar la pagina.
  document.addEventListener('shopify:section:load', boot);
})();